 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"BackOffice-blog~about~back-office-bookings~back-office-reservations~banners~categories~contact-us-me~41680b80":"BackOffice-blog~about~back-office-bookings~back-office-reservations~banners~categories~contact-us-me~41680b80","BackOffice-blog":"BackOffice-blog","about":"about","back-office-bookings~general-feedbacks~rooms":"back-office-bookings~general-feedbacks~rooms","back-office-bookings":"back-office-bookings","general-feedbacks~rooms":"general-feedbacks~rooms","general-feedbacks":"general-feedbacks","rooms":"rooms","back-office-reservations":"back-office-reservations","banners":"banners","categories":"categories","contact-us-messages":"contact-us-messages","guest-feedbacks":"guest-feedbacks","newsletters":"newsletters","our-team":"our-team","products":"products","users":"users","about-us":"about-us","add-product":"add-product","edit-product":"edit-product","event-calendar~general-calendar":"event-calendar~general-calendar","event-calendar":"event-calendar","general-calendar":"general-calendar","general-reviews":"general-reviews","guest-reviews":"guest-reviews","home":"home","login":"login"}[chunkId]||chunkId) + "." + {"BackOffice-blog~about~back-office-bookings~back-office-reservations~banners~categories~contact-us-me~41680b80":"6c055668","BackOffice-blog":"be55425c","about":"498292aa","back-office-bookings~general-feedbacks~rooms":"e2ebc393","back-office-bookings":"91cd5961","general-feedbacks~rooms":"fca633b0","general-feedbacks":"5111984d","rooms":"2ea4bc60","back-office-reservations":"791dd6f3","banners":"4dcfd346","categories":"3b485d93","contact-us-messages":"cf54c2a0","guest-feedbacks":"03a95cc0","newsletters":"8763674c","our-team":"40f722b1","products":"6520f61a","users":"8815d9af","about-us":"7b1fc4ea","add-product":"e93c25f0","edit-product":"f4eca2c8","event-calendar~general-calendar":"90609865","event-calendar":"dc3c1fd7","general-calendar":"be22bcf7","general-reviews":"bb0c0122","guest-reviews":"e891feab","home":"8026984a","login":"84301ad6","chunk-2d216214":"9867b1bd","chunk-2d216257":"dbf455e4","chunk-514fc6e9":"9c874085"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BackOffice-blog":1,"about":1,"back-office-bookings~general-feedbacks~rooms":1,"back-office-bookings":1,"general-feedbacks":1,"rooms":1,"back-office-reservations":1,"banners":1,"categories":1,"contact-us-messages":1,"guest-feedbacks":1,"newsletters":1,"our-team":1,"products":1,"users":1,"about-us":1,"add-product":1,"edit-product":1,"event-calendar":1,"general-calendar":1,"general-reviews":1,"guest-reviews":1,"home":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"BackOffice-blog~about~back-office-bookings~back-office-reservations~banners~categories~contact-us-me~41680b80":"BackOffice-blog~about~back-office-bookings~back-office-reservations~banners~categories~contact-us-me~41680b80","BackOffice-blog":"BackOffice-blog","about":"about","back-office-bookings~general-feedbacks~rooms":"back-office-bookings~general-feedbacks~rooms","back-office-bookings":"back-office-bookings","general-feedbacks~rooms":"general-feedbacks~rooms","general-feedbacks":"general-feedbacks","rooms":"rooms","back-office-reservations":"back-office-reservations","banners":"banners","categories":"categories","contact-us-messages":"contact-us-messages","guest-feedbacks":"guest-feedbacks","newsletters":"newsletters","our-team":"our-team","products":"products","users":"users","about-us":"about-us","add-product":"add-product","edit-product":"edit-product","event-calendar~general-calendar":"event-calendar~general-calendar","event-calendar":"event-calendar","general-calendar":"general-calendar","general-reviews":"general-reviews","guest-reviews":"guest-reviews","home":"home","login":"login"}[chunkId]||chunkId) + "." + {"BackOffice-blog~about~back-office-bookings~back-office-reservations~banners~categories~contact-us-me~41680b80":"31d6cfe0","BackOffice-blog":"61a4f805","about":"e4b971cb","back-office-bookings~general-feedbacks~rooms":"d4b2cc0b","back-office-bookings":"0baa8610","general-feedbacks~rooms":"31d6cfe0","general-feedbacks":"9710e3cb","rooms":"9710e3cb","back-office-reservations":"210fbf54","banners":"5640fe18","categories":"5640fe18","contact-us-messages":"61a4f805","guest-feedbacks":"61a4f805","newsletters":"61a4f805","our-team":"071fd54b","products":"087afa28","users":"5640fe18","about-us":"c1ce3122","add-product":"e863d5e3","edit-product":"4e38ea17","event-calendar~general-calendar":"31d6cfe0","event-calendar":"a326ee6a","general-calendar":"e8c14076","general-reviews":"b0ebf55a","guest-reviews":"7efe8731","home":"ce99efb7","login":"e60e4cc0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-514fc6e9":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
